import { SERVER_URL } from "../../utils/constants";
import HttpRequest from "../../utils/HttpRequest";

export const getAllTopbarber_client_serviceService = async (query) => {
  return HttpRequest.get(`${SERVER_URL}/newWay/cart/dashboard_statistics${query || "?"}`);
};